import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const whitelistingTrackerPlugin = createPlugin({
  id: 'whitelisting-tracker',
  routes: {
    root: rootRouteRef,
  },
});

export const WhitelistingTrackerPage = whitelistingTrackerPlugin.provide(
  createRoutableExtension({
    name: 'WhitelistingTrackerPage',
    component: () =>
      import('./components/WhitelistingTrackerPage/WhitelistingTrackerPage').then(m => m.WhitelistingTrackerPage),
    mountPoint: rootRouteRef,
  }),
);
